import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles(() => ({
  root: {
    color: (props) => props.color,
    fontSize: (props) => props.size,
    fontWeight: (props) => props.fontWeight,
  },
}));

function GenericIcon({ ...props }) {
  const { color, size, fontClass, fontWeight } = props;
  const classes = useStyles({ color, size, fontWeight });
  return <span className={`${fontClass} ${classes.root}`} />;
}

GenericIcon.propTypes = {
  color: PropTypes.string,
  size: PropTypes.string,
  fontClass: PropTypes.string,
  fontWeight: PropTypes.string,
};

export default GenericIcon;
